module.exports = __webpack_public_path__ + "img/04C455_0EFABC_04F097_04E17A-256px.68cf5485.png";